import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import {Grid, Row, Button} from 'react-bootstrap'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'
import HorseAdBox from '../Common/HorseAdBox/HorseAdBox'

import './Layout/AdsByTopicScreen.css'

class AdsByTopicScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      type: props.params.type,
      page: 1,
      data: [],
      showMoreButton: false,
      hasNextPage: false,
      isLoading: true,
      showNotFound: false,
      nextPageData: []
    }
    this.nextPage = this.nextPage.bind(this)

    this.hideShowMoreAndLoadNextPage = this.hideShowMoreAndLoadNextPage.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.calculateHasNextPage = this.calculateHasNextPage.bind(this)
    this.loadAds = this.loadAds.bind(this)
    this.isNextPageData = this.isNextPageData.bind(this)
  }

  isNextPageData (nextPage) {
    return this.state.page !== nextPage
  }

  loadAds (type) {
    return Actions.loadAdsByTopic({type: type, page: 1}).catch((e) => {
      if (e.response.status === 404) {
        this.setState({isLoading: false, showNotFound: true})
      }
    })
  }

  calculateHasNextPage (currentPage) {
    Actions.takeAdsByTopicEffect({type: this.state.type, page: parseInt(currentPage, 10) + 1}).then((res) => {
      this.setState({hasNextPage: true, nextPageData: res.data})
    }).catch((e) => {
      this.setState({hasNextPage: false, nextPageData: []})
    })
  }

  handleScroll () {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight
    const body = document.body
    const html = document.documentElement
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
    const windowBottom = windowHeight + window.pageYOffset
    if (windowBottom >= docHeight) {
      this.nextPage()
    }
  }

  componentWillMount () {
    if (this.props.ad.fullList.length > 0 && this.props.ad.type === this.props.params.type) {
      return this.setState({
        data: this.props.fullList,
        isLoading: false,
        type: this.props.params.type,
        showNotFound: false,
        page: 1
      }, () => this.calculateHasNextPage(1))
    }
    if (window.__BROWSER_ENV__) {
      this.loadAds(this.props.params.type)
    }
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  componentWillReceiveProps (nextProps) {
    const newType = nextProps.params.type

    if (nextProps.ad.type === nextProps.params.type && nextProps.ad.fullList.length > 0) {
      if (newType !== this.props.ad.type) {
        return undefined
      }

      if (this.state.data.length > 0 && (nextProps.ad.fullList[0].id === this.props.ad.fullList[0].id || this.isNextPageData(nextProps.ad.page))) {
        return undefined
      }

      this.setState({
        data: (this.state.data === [] || newType !== this.props.ad.type) ? nextProps.ad.fullList : [...this.state.data, ...nextProps.ad.fullList],
        type: nextProps.ad.type,
        isLoading: false
      }, () => this.calculateHasNextPage(this.state.page))

      if (this.state.type !== newType) {
        this.setState({
          type: newType,
          page: 1
        }, () => this.loadAds(newType))
      }
    }
  }

  nextPage () {
    if (this.state.showMoreButton) {
      return undefined
    }

    if (this.state.hasNextPage) {
      let nextPage = this.state.page + 1
      this.setState({
        data: [...this.state.data, ...this.state.nextPageData],
        page: nextPage,
        showMoreButton: (nextPage % 3) === 0
      }, () => this.calculateHasNextPage(nextPage))
    }
  }

  hideShowMoreAndLoadNextPage () {
    this.setState({showMoreButton: false})
    this.nextPage()
  }

  render () {
    const { isLoading, showMoreButton, showNotFound, data } = this.state
    const topicName = () => {
      switch (this.props.params.type) {
        case 'sale':
          return 'آگهی‌های فروش'
        case 'belly-rental':
          return 'آگهی‌های اجاره شکم'
        case 'mate':
          return 'آگهی‌های کشش'
        default:
          return 'دیگر آگهی‌ها'
      }
    }
    return (
      <div className="Ads" id="ads-screen">
        {isLoading ? <HorseLoading />
          : showNotFound ? <NotFound route={this.props.location} />
            : <Grid>
              <Row>
                <h2>{topicName()}</h2>
                {data.length > 0 && data.map((item, index) => (
                  <HorseAdBox key={index} ad={item} />
                ))}
              </Row>
              <Row className="MoreButton">
                {showMoreButton && <Button bsStyle="info" onClick={this.handleNextPage} block>نمایش بیشتر...</Button>}
              </Row>
            </Grid>
        }
      </div>
    )
  }
}

AdsByTopicScreen.fetchData = ({params}) => {
  return Actions.loadAdsByTopic({type: params.type})
}

function mapStateToProps (state) {
  return {
    ad: state.ad
  }
}

export default connect(mapStateToProps)(AdsByTopicScreen)



// WEBPACK FOOTER //
// ./src/components/Ad/AdsByTopicScreen.js